/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';

export const getDpFanQuizSuccessPage = (_: IncomingContent): Layout => ({
	name: 'HomeStack',
	slots: {
		header: [],
		first: [{ name: 'DpFanQuizSuccess', id: 'dp-fan-quiz-success-page' }],
		second: [],
		footer: [],
	},
});
